export const getCookieSuffix = () => {
  const env = getEnvironment();
  return env === 'prod' ? '' : env.replace('-', '');
};

export const getEnvironment = () => {
  const disambiguator = import.meta.env.VITE_API_DISAMBIGUATOR ?? 'unknown';
  return disambiguator === '' ? 'prod' : disambiguator;
};

/** True when running in dev mode (Vite dev server, NODE_ENV=development). Use for dev-only behavior like console logs. */
export const isDev = (): boolean =>
  (typeof import.meta !== 'undefined' &&
    (import.meta as { env?: { DEV?: boolean } }).env?.DEV === true) ||
  (typeof process !== 'undefined' && process.env.NODE_ENV === 'development');

// Helper function that checks for localStorage override
const getEnvironmentWithOverride = () => {
  try {
    const override = localStorage.getItem('envOverride');
    // Only allow overriding to production, not to staging
    if (override === 'prod') {
      return 'prod';
    }
  } catch (e) {
    // Ignore localStorage errors (may happen in SSR or when cookies disabled)
  }
  return getEnvironment();
};

export const isNonProduction = () => getEnvironmentWithOverride() !== 'prod';
export const isProduction = () => getEnvironmentWithOverride() === 'prod';
export const isStaging = () => getEnvironment() === '-staging';
